import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useResendVerificationEmailMutation } from "../../../store/services/AuthService";
import { getErrorMessage } from "../../../utils/utils";
import { AuthWrapper } from "../../components/common/wrappers/AuthWrapper";

function ResendVerificationEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [resendVerificationEmail, { isLoading }] = useResendVerificationEmailMutation();
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate("/login");
    }
  }, [email, navigate]);

  const handleResend = async () => {
    try {
      const response = await resendVerificationEmail({email}).unwrap();

      if (!response?.succeeded) {
        getErrorMessage(response?.errors?.[0]);
      } else {
        setEmailSent(true);
      }
    } catch (error) {
      console.log("🚀 ~ resend verification error:", error);
      getErrorMessage(error?.data?.errors?.[0] || "Something went wrong.");
    }
  };

  return (
    <AuthWrapper>
      {emailSent ? (
        <>
          <div>
            <h4 className="fs-20 mt-4">Verification Link Sent</h4>
            <p className="mb-4">Please check your email <strong>{email}</strong> to verify your account!</p>
          </div>
          <div className="btn btn-link p-0 mt-2 text-decoration-none text-primary">
            <p>
              <Link
                className="text-primary"
                to="/login"
              >
                ← Back to Login
              </Link>
            </p>
          </div>
      </>
      ) : (
        <div>
          <h4 className="fs-20 mt-4">Send Verification Email</h4>
          <p className="mb-4">Click below to send the verification email.</p>

          <button
            onClick={handleResend}
            className="btn btn-primary btn-block"
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Send Verification Link"}
          </button>

          <div className="new-account mt-3">
            <p>
              Already verified?{" "}
              <Link
                className="text-primary"
                to="/login"
              >
                Sign in
              </Link>
            </p>
          </div>
        </div>
      )}
    </AuthWrapper>
  );
}

export default ResendVerificationEmail;